import { render, staticRenderFns } from "./SpaceChoose.vue?vue&type=template&id=2e34f23a&scoped=true&"
import script from "./SpaceChoose.vue?vue&type=script&lang=js&"
export * from "./SpaceChoose.vue?vue&type=script&lang=js&"
import style0 from "./SpaceChoose.vue?vue&type=style&index=0&id=2e34f23a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e34f23a",
  null
  
)

export default component.exports